let config = {};

config.githubToken = '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';
config.githubUsername = 'VaibhavAswal';

module.exports = config;